import { Component, OnInit } from '@angular/core';
import { Actions } from 'bqx-deal';
import { Subject } from 'rxjs';
import { ApplicationFormAbstractService } from 'src/app/services/application-form/application-form.abstract.service';
import { AbstractDealAnalyticsService } from 'src/app/services/deal-analytics/abstract-deal-analytics.service';

@Component({
  selector: 'appform-question-set-save-button',
  templateUrl: './question-set-save-button.component.html',
  styleUrls: ['./question-set-save-button.component.css']
})
export class QuestionSetSaveButtonComponent implements OnInit {

  public enable$ = new Subject<boolean>();
  public disabled: boolean;

  constructor(private applicationFormService: ApplicationFormAbstractService, private dealAnalyticsService: AbstractDealAnalyticsService) { }

  ngOnInit(): void {
    this.enable$ = this.applicationFormService.activeQuestionComplete$;
  }

  public saveQuestionSet() {
    this.dealAnalyticsService.postDealControlEvent(Actions.ButtonClick, 'Next');
    if(this.applicationFormService.isAppSyncedWithBP$.value){
      this.applicationFormService.saveBusinessInfoQSet();
    } else {
      this.applicationFormService.saveQuestionSet();
    }
  }
}
